import "./index.scss";
import { Button, Text, TextField } from "@mbank-design/design-system/components";
import { ButtonSize, ButtonType } from "@mbank-design/design-system/components/Button/Button.constants";
import { FontSize, FontWeight, LineHeight } from "@mbank-design/design-system/design-tokens/general/typography";

export interface CalculatorPromoCodeBarProps {
    promoCode: string;
    setPromoCode: (promoCode: string) => void;
    applyPromoCode: () => void;
    message: string;
    success: boolean;
    isLoading?: boolean;
    /** "success" - green bar, "error" - red bar, null - default */
    status?: "success" | "error" | null;
}

export const CalculatorPromoCodeBar = ({ promoCode, setPromoCode, applyPromoCode, message, success, isLoading = false, status = null }: CalculatorPromoCodeBarProps) => {
  return <div>
    <div className={`promo-code-bar${status ? ` promo-code-bar--${status}` : ""}`}>
        <div className="promo-code-bar__content">
            <div className="promo-code-bar__content__title">
                <Text fontSize={FontSize.SIZE_12} as={"p"} fontWeight={FontWeight.WEIGHT_700} lineHeight={LineHeight.HEIGHT_16}>
                    kod promocyjny
                </Text>
            </div>
            <div className="promo-code-bar__content__input">
                <div className="promo-code-bar__content__field">
                    <TextField className="promo-code-bar__field" placeholder="wpisz kod promocyjny" onChange={(_event, value) => setPromoCode(value)} value={promoCode}  />
                </div>
                <Button buttonType={ButtonType.PRIMARY} onClick={applyPromoCode} size={ButtonSize.SMALL} disabled={promoCode.trim().length === 0 || success || isLoading}>
                    Zastosuj
                </Button>
            </div>
            {message && (
                <div className={`promo-code-bar__content__message promo-code-bar__content__message--${status ?? (success ? "success" : "error")}`}>
                    <Text fontSize={FontSize.SIZE_12} as={"p"} fontWeight={FontWeight.WEIGHT_600} lineHeight={LineHeight.HEIGHT_16}>
                        {message}
                    </Text>
                </div>
            )}
        </div>
    </div>
  </div>;
};